<template>
	<div class="TipsDialog">
		<DialogFrom width="750px" title="公司资质完善提示" leftText="取消" rigthText="前往" :OKASCAN="false" :CancelFlag="false"
			:dialogVisible="show" @cancel="cancel" @dialogOK="submit">
			<div class="DialogContent">
				<div class="Title">
					为避免影响后续业务进行，请尽快前往 “公司信息” 版块 完成以下项目维护：
				</div>
				<div class="Content">
					<div class="ct-item" v-for="(item,index) in authList" :key="index">
						<div class="item-key">{{item.key}}:</div>
						<div class="item-val" :style="{ color: item.value > 0 ? 'green' : 'red' }">{{ item.value > 0 ?
							'已认证' : item == 0 ? '未认证' :'已驳回' }}</div>
					</div>
				</div>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import DialogFrom from '../../../../../components/dialog-from.vue'

	import {
		GetLicenseRemindAuthorityLicense
	} from '@/api/newsapi'
	export default {
		props: {
			isOpen: { //是否一开始就调用
				type: Boolean,
				default: false
			}
		},
		components: {
			DialogFrom
		},
		data() {
			return {
				show: false,
				authList: null,
				pathObj: {
					"营业执照": "/License/BusinessLicense?MenuID=69&NodeID=68",
					"医疗器械经营许可证": "/License/BusinessPermission?MenuID=70&NodeID=68",
					"第二类医疗器械备案凭证": "/License/BusinessRecord?MenuID=71&NodeID=68",
					"开户许可证": "/License/OpenAccount?MenuID=95&NodeID=68",
					"经销商信息表": "/homeCom/CusInfo?MenuID=96&NodeID=61",
					"业务员授权书": "/homeCom/SalerBusinessAuthority?MenuID=97&NodeID=61",
					"承诺函": "/homeCom/CommitmentLetter?MenuID=98&NodeID=61",
					"关联申明": "/homeCom/AffiliateStatement?MenuID=99&NodeID=61",
					"联系信息": "/homeCom/FileContact?MenuID=100&NodeID=61",
				}
			}
		},
		created() {
			if (this.isOpen) {
				this.getData();
			}
		},
		methods: {
			async getData() {
				let {
					code,
					data,
					message
				} = await GetLicenseRemindAuthorityLicense({})
				if (code == 0 && data) {
					if (data.length) {
						let getAll = data.filter(item => item.value == 0 || item.value == -1);
						if (getAll.length > 0) {
							this.authList = data;
							this.show = true;
						}
					}
				}
			},
			cancel() {
				this.show = false;
			},
			submit() {
				let fdIndex = this.authList.findIndex(item => item.value === 0);
				this.$router.push(this.pathObj[this.authList[fdIndex].key]);
			}
		}
	}
</script>
<style lang="less">
	.DialogContent {
		padding: 0px 24px;

		.Title {
			font-size: 18px;
			font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
			font-weight: 500;
			color: #333333;
		}

		.Content {
			padding: 12px 0px;

			.ct-item {
				display: flex;
				align-items: center;
				margin-bottom: 12px;

				.item-key {
					font-size: 14px;
					font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
					font-weight: 400;
					color: #333333;
				}

				.item-val {
					font-size: 14px;
					font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
					font-weight: 400;
					color: #333333;
				}
			}
		}
	}
</style>